import React from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { View } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { CategoryProps, LeaderProps, TimerangeProps } from "../../../store/types/analytics_svc"
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { Icon } from 'react-native-elements';

type PlayerLeaderCardProps = {
    leader:LeaderProps,
    category:CategoryProps,
    time_range:TimerangeProps,
    view_mode?:string,
    width:number,
    onPin?:(leader:LeaderProps) => void,
    onSelect:(leader:LeaderProps) => void
}
const PlayerLeaderCard = ({ view_mode, leader, category, time_range, width, onSelect, onPin }:PlayerLeaderCardProps) => {

    const handlePin = () => {
        if(!onPin){ return }
        return onPin(leader)
    }

    return (
        <LinearGradient start={[0, 0.5]} end={[1, 0.5]} colors={[Colors.brand.midnight, '#003a87']} style={{ width, margin:5, borderRadius:8}} >
            <TouchableOpacity onPress={() => onSelect(leader)}>
                <View style={{ flexDirection:'row', alignItems:'flex-start', padding:10 }}>
                    <View style={{ flex:1 }}>
                        <Text size={14} color={Colors.shades.white}>{category.name}</Text>
                        <View style={{marginTop:8, marginBottom:8, width:40, borderWidth:1, borderColor:Colors.brand.slate, opacity:0.5 }}/>
                    </View>
                    <View style={{ padding:5, backgroundColor:Colors.shades.white, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                        <Text size={12} weight='bold' color={Colors.brand.midnight}>{leader.leaderboard_eligible?leader.place:'N/A'}</Text>
                    </View>
                </View>
                
                <View style={{ flex:1, flexDirection:'row', alignItems:'flex-start', marginTop:5, padding:10 }}>
                    <Text style={{ flex:1/2 }} size={20} color={Colors.shades.white} weight='bold'>{category?.stat_label_loc==='prefix'?category.stat_label:''}{leader.category_score.toFixed(2)}{category?.stat_label_loc==='suffix'?category.stat_label:''}</Text>
                    <View style={{ flex:1/2, alignItems:'flex-end' }}>
                        <View style={{ padding:4, backgroundColor:Colors.shades.white, borderRadius:6 }}>
                            <Text size={12} color={Colors.brand.midnight}>{time_range.name}</Text>
                        </View>
                    </View>
                    
                </View>
            </TouchableOpacity>
            {view_mode === 'edit' ?
            <TouchableOpacity 
                style={{ padding:5, flexDirection:'row', alignItems:'center', justifyContent:'space-between', backgroundColor:Colors.shades.white, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}
                onPress={() => handlePin()}>
                <View style={{ flex:1, alignItems:'flex-start' }}>
                    <Icon size={18} name={leader.pinned?'star':'star-outline'} type='ionicon' color={leader.pinned?Colors.incentive.gold:Colors.shades.shade100} />
                </View>
                <Text size={14} color={Colors.brand.midnight}>Pin Metric</Text>
            </TouchableOpacity>
            :<></>}
        </LinearGradient>   
    )
}

export default PlayerLeaderCard


